export const ArrowDown = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 10L12 15L18 10" stroke="currentColor" strokeWidth="2" />
  </svg>
)
